<div md-dialog-content class="w-100 text-center mt-2 p-3">{{confirmMessage}}</div>
<div md-dialog-actions>
  <div class="w-100 text-center mt-2 mb-2">
    <button class="btn btn-primary mr-3" (click)="dialogRef.close(true)">Confirm</button>
    <button class="btn btn-warning ml-3" (click)="dialogRef.close(false)">Cancel</button>
  </div>
</div>
